import type { schemaType as dealsHomeType } from '~~/shared/api/rurality/v3/deals/home/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-cards-deals.vue'

export const useToSCardsDeals = () => {
  const fromDealsHome = (data: dealsHomeType): propsInterface => {
    const MAX_CHARACTERS = 200

    let items: propsInterface['items'] = []

    items = data.deals.map(item => {
      return {
        url: routes().dealDetail({ slug: item.slug, id: item.id }),
        src: item.imageUrl,
        discountPercent: t('landings.home.deals.discount', {
          number: item.discountPercent,
        }),
        title: item.title,
        subtitle: item.provinceName,
        description: cropText(item.description, MAX_CHARACTERS),
        nights: t('landings.home.deals.nights', {
          nights: item.nights,
          dateIn: toRuralityDate().displayDate(item.dateIn),
          dateOut: toRuralityDate().displayDate(item.dateOut),
        }),
        pricePersonNight: t('landings.home.deals.people', {
          number: item.numPersons,
          price: toEuro(item.pricePersonNight.amount),
        }),
        priceNew: t('landings.home.deals.old-price', {
          price: toEuro(item.priceNew.amount),
        }),
        priceOld: t('landings.home.deals.new-price', {
          price: toEuro(item.priceOld.amount),
        }),
        buttonText: t('landings.home.deals.card-button'),
      }
    })

    return { items }
  }

  return { fromDealsHome }
}
